import { render, staticRenderFns } from "./Developers.vue?vue&type=template&id=5d106342&scoped=true"
import script from "./Developers.vue?vue&type=script&lang=js"
export * from "./Developers.vue?vue&type=script&lang=js"
import style0 from "./Developers.vue?vue&type=style&index=0&id=5d106342&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d106342",
  null
  
)

/* custom blocks */
import block0 from "./Developers.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(component)

export default component.exports